import React from 'react';

import { Button } from 'components/ui/button';
import { Dialog } from '@buildoutinc/blueprint-react/ui/Dialog';

interface Props {
  show: boolean;
  onDelete: () => void;
  onHide: () => void;
}

export default function AttachmentDeletionConfirmation({ show, onDelete, onHide }: Props) {
  return (
    <Dialog open={show} onClose={onHide}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Delete Attachment</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p>Are you sure you want to delete this attachment?</p>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Cancel>Cancel</Dialog.Cancel>
          <Button label="Delete" variant="destructive" onClick={onDelete} />
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
